import { Component, AfterViewInit, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { LoaderService } from './services/loader.service';
@Component({
    // tslint:disable-next-line
    selector: 'body',
    template: '<router-outlet><span [hidden]="!showLoader" class="loading"></span></router-outlet>',
    //    styleUrls: ['./services/app.component.css']
    //    template: '<router-outlet><ngx-loading [show]="showloading" ></ngx-loading></router-outlet>'
})
export class AppComponent implements AfterViewInit {
    showLoader: boolean;
    public viewContainerRef: ViewContainerRef;
    constructor(
        private loaderService: LoaderService,
        public toastr: ToastsManager,
        vcr: ViewContainerRef
    ) {
        this.viewContainerRef = vcr;
        this.toastr.setRootViewContainerRef(this.viewContainerRef);
    }

    ngAfterViewInit() {
        window.setTimeout(() => {
            this.loaderService.status.subscribe((val: boolean) => {
                this.showLoader = val;
            });
        });
    }
}



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/app.component.ts